module.exports = __webpack_public_path__ + "img/metamask.4c149409.png";